import api from "@/api";

export interface PasswordToken {
  token: string;
}

export default async function getPasswordRecoveryToken(document: string, code: string): Promise<PasswordToken> {
  const response = await api.post<PasswordToken>("/api/password/check", {
    document: document.replace(/[^A-Z0-9]/gi, ""),
    code,
  });

  return response.data;
}
